import { projectV3Builder } from './v3';

// TODO: Think about it
export const projectBuilder = projectV3Builder;
